import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 0 522 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m353 421-4-1h-24q-26-2-67-1-86 3-97-2l-3-1v-6q0-9 7-15 19-16 112-18h10l-8-2q-44-9-61-39-15-27 5-49 12-12 39-12 14 0 18 1l7 1q0-2-1-4-11-19-42-21-35-3-50 27-5 13-5 29 0 14 1 20l2 9-11 18q-37 58-49 63-3 1-22 2-24 0-31-4-2-1-2-7 0-11 5-16 6-7 26-10 12-2 14.5-5t3.5-16q3-29 6-40 6-25-3-48-7-18-7-27-2-11 2-21l1-3-4-1q-23-3-28-5-27-6-30-22-8-32 25-75 20-26 46-35 21-5 44 0 1 1 1.5 0t2.5-4q7-16 40-39 38-25 72-25 15 0 18 9 2 8-5.5 14T276 56q-12 5-12 6 2-1 5-2 42-14 65 2 11 8 6 17-5 5-29 11-34 11-52 21-12 6-26 14l-11 6 1 8q4 15 17 20 9 3 45 6 44 3 60 10 9 5 17 12 43 39 55 87 3 22 2 31v6h6q17 3 23 18 3 6 3 13 0 5-2 13-7 14-21 17-17 5-38-10l-3-2-1 2q-1 2-1.5 10t.5 13l3 12q3 10 1 16-1 2-10 7-3 1-13 1.5t-13-.5M135 171q10-5 9.5-16.5T134 138q-7-4-14 0-8 4-9 11-1 6 0 11 2 8 9.5 11.5t14.5-.5"
    }, null, -1)
  ])))
}
export default { render: render }